module.exports = __webpack_public_path__ + "img/6a9abc5bed09764fc91eb13573681985.png";